module.exports = __webpack_public_path__ + "img/Doelgroep.9ff4cd31.webp";